module.exports = __webpack_public_path__ + "static/img/14c.fa9b631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14c.jpg
// module id = q6ju
// module chunks = 0